import {Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'app-decoration-headline',
    templateUrl: './decoration-headline.component.html',
    styleUrls: ['./decoration-headline.component.css'],
})
export class DecorationHeadlineComponent implements OnInit {

    @Input() backgroundName = 'light-mint';

    get decorationBackgroundPath() {
        return `/assets/decoration/shapes/shape-${this.backgroundName}.svg`;
    }

    constructor() {
    }

    ngOnInit() {
    }

}
